import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

import { Close, HiLoNoBalanceCSS } from './HiLoNoBalanceCSS.styled'
import { useUser } from 'hooks/user/useUser'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

export const HiLoNoBalance = ({ layoutId, onClose }) => {
  const navigateTo = useNavigate()
  const { isConnected } = useUser('wallet')

  const onDepositClick = () => {
    if (!isConnected) return
    navigateTo(`/game/${CONTENT_TYPES.WALLET}`)
  }
  return (
    <HiLoNoBalanceCSS>
      <motion.div layoutId={layoutId} className='overlay'>
        <Close masking onClick={onClose} />
        <button id='btnPad'>Insufficient balance</button>
        <button onClick={onDepositClick}>Deposit?</button>
      </motion.div>
    </HiLoNoBalanceCSS>
  )
}
